import get from 'lodash/get';
import { setCurrentPatientId, setPatientById, setPatients } from './actions';
import PatientService from './PatientService';
import { toAddressRequest } from '../util';

// Helpers
const toRequest = ({
  addressId,
  addressState,
  birthday,
  city,
  firstName,
  gender,
  id,
  lastName,
  secondaryStreetAddress,
  streetAddress,
  additionalNotes,
  notes,
  userId,
  zipCode,
}) => {
  return {
    ...toAddressRequest({
      addressId,
      addressState,
      city,
      secondaryStreetAddress,
      streetAddress,
      zipCode,
    }),
    id,
    birthday,
    firstName,
    lastName,
    gender,
    userId,
    additionalNotes,
    notes,
  };
};

// Thunks
export const fetchPatientsAsync = userId => dispatch => {
  return dispatch(PatientService.getByUserId(userId)).then(patients => {
    const currentPatientId = get(patients, ['0', 'id']); // Only one patient at a time currently
    dispatch(setCurrentPatientId(currentPatientId));
    return dispatch(setPatients(patients));
  });
};

export const updatePatientAsync = patient => dispatch => {
  return dispatch(
    PatientService.update({
      id: patient.id,
      patient: toRequest(patient),
    }),
  ).then(() =>
    dispatch(
      setPatientById({
        patient,
        id: patient.id,
      }),
    ),
  );
};



// WEBPACK FOOTER //
// ./src/lib/dataLayer/patient/thunks.js